import Api from "lib/api";

const api = Api.getInstance();

const ns = "app/dashboards/nonprofit";

export const LOAD_START = ns + "LOAD_START";
export const LOAD_FAILURE = ns + "LOAD_FAILURE";
export const LOAD_SUCCESS = ns + "LOAD_SUCCESS";

export function loadData () {
    return async (dispatch) => {
        dispatch({
            type: LOAD_START
        });

        try {
            const response = await api.get('dashboards');

            dispatch({
                type: LOAD_SUCCESS,
                payload: response.data
            });

        } catch (error) {
            dispatch({
                type: LOAD_FAILURE,
                payload: error.response
            });
        }

    };
}


// WEBPACK FOOTER //
// ./src/components/app/dashboard/actions.js